import { getWorkdayProjects } from '@lib/api'
import { workdayProjectsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useWorkdayProjects = () => {
  return useQuery(workdayProjectsKeys.all, () => getWorkdayProjects())
}
